import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=20b0a166&lang=pug"
import script from "./Simple.vue?vue&type=script&lang=ts"
export * from "./Simple.vue?vue&type=script&lang=ts"
import style0 from "./Simple.vue?vue&type=style&index=0&id=20b0a166&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports